// Development-only console wrapper. Any `debug()`/`warn()` calls silently
// no-op in production builds so we don't leak internal state or spam the
// browser console for real users. Use for best-effort/silent-fail poll
// loops where surfacing the error to the user isn't useful.
const isDev = process.env.NODE_ENV !== "production";

export const devLog = {
  debug: (...args) => { if (isDev) console.debug(...args); },
  warn:  (...args) => { if (isDev) console.warn(...args); },
};
